// extracted by mini-css-extract-plugin
export default {"ESginContainer":"ESign_ESginContainer__4YJx5"};